import { createRoot } from 'react-dom/client';
import '../external_parties';

// React's default onCaughtError also logs caught errors via console.error, which Datadog RUM
// captures automatically as a separate "console" error, duplicating whatever the app's
// ErrorBoundary already reports explicitly via datadogRum.addError.
function onCaughtError(error, errorInfo) {
  if (!process.env.DATADOG_APP_ID) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo.componentStack);
  }
}

export function mountApp(node) {
  const container = document.getElementById('root');
  const root = createRoot(container, { onCaughtError });
  root.render(node);
}
